var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09677 38.5C4.80708 38.5 6.19355 39.8431 6.19355 41.5V51.5C6.19355 55.366 9.42865 58.5 13.4194 58.5H50.5806C54.5713 58.5 57.8064 55.366 57.8064 51.5V41.5C57.8064 39.8431 59.1929 38.5 60.9032 38.5C62.6135 38.5 64 39.8431 64 41.5V51.5C64 58.6797 57.9919 64.5 50.5806 64.5H13.4194C6.00805 64.5 0 58.6797 0 51.5V41.5C0 39.8431 1.38647 38.5 3.09677 38.5Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.875 21.2694L29.8875 1.41383C31.0542 0.195391 32.9458 0.195391 34.1125 1.41383L53.125 21.2694C54.2917 22.4878 54.2917 24.4633 53.125 25.6817C51.9583 26.9002 50.0667 26.9002 48.9 25.6817L34.9875 11.1523V47.5C34.9875 49.2231 33.65 50.62 32 50.62C30.35 50.62 29.0125 49.2231 29.0125 47.5V11.1523L15.1 25.6817C13.9333 26.9002 12.0417 26.9002 10.875 25.6817C9.70832 24.4633 9.70832 22.4878 10.875 21.2694Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.bdb4f5a1070fd4d81d0e2f3b47f73c53.svg";
export { ForwardRef as ReactComponent };